import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { setShowOtpPopup } from 'redux-thunk/redux/slices/settings.slice'
import { verifyOtp } from 'redux-thunk/thunk/auth.thunk'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import ErrorMessage from 'components/layout/ErrorMessage'
import { useTranslation } from 'react-i18next'
import GoldButton from 'components/ui-kit/GoldButton/index'

const FORM_CONTROL =
  'box-border h-10 w-full rounded-[0.625rem] border border-solid border-[var(--darkGray)] bg-[var(--darkGray)] px-3 py-1 text-base text-[var(--white)] shadow-none outline-none placeholder:!text-[var(--gray-20)] focus:border-[var(--blue-300)] focus:bg-[var(--darkGray)] focus:text-[var(--white)] focus:outline-none focus:shadow-none focus-within:shadow-none disabled:cursor-not-allowed disabled:bg-[var(--gray-90)] disabled:text-[var(--white)] read-only:bg-[var(--gray-90)] read-only:text-[var(--white)]'

const OtpPopup = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const schema = yup.object().shape({
    otp: yup
      .string()
      .required(t('otpIsRequired'))
      .length(6, t('otpMustBeSixDigits'))
  })

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'all'
  })

  const handleOtpSubmit = (data) => {
    dispatch(verifyOtp({ OTP: data.otp }))
  }

  const modalCloseHandler = useCallback(() => {
    dispatch(setShowOtpPopup(false))
  }, [])

  return (
    <CommonPopup
      modalCloseHandler={modalCloseHandler}
      id='otpModal'
      modalBodyClasses='!p-0'
      modalDialogClass='!max-w-[400px]'
    >
      <div className='px-4 pb-0 pt-4'>
        <h4 className='uppercase'>
          {t('emailChangeOtpSent')}
        </h4>
      </div>
      <form onSubmit={handleSubmit(handleOtpSubmit)}>
        <div className='px-4'>
          <div className='relative mb-2'>
            <div className='mb-2'>
              <input
                type='number'
                className={`${FORM_CONTROL} ${errors?.otp ? '!border-[var(--c)] focus:!border-[var(--c)]' : ''}`}
                id='otp'
                name='otp'
                placeholder={t('enterOtp')}
                {...register('otp', { valueAsNumber: true })}
              />
              {errors && errors.otp && (
                <div>
                  <ErrorMessage
                    className='flex text-[var(--red)]'
                    message={errors.otp.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='border-0 px-4 pb-4'>
          <GoldButton type='submit'>
            {t('verifyOtp')}
          </GoldButton>
        </div>
      </form>
    </CommonPopup>
  )
}

export default OtpPopup
